/**
 * @file Déclenche le téléchargement d'un fichier reçu en mémoire (Blob) dans le navigateur.
 * @module packages.common.utils.downloadFile
 *
 * Point unique pour tout téléchargement généré par l'API (CSV, PDF, archive) :
 * crée une URL temporaire, simule un clic sur un lien de téléchargement et
 * libère la ressource aussitôt.
 */

/**
 * Télécharge un contenu binaire sous un nom de fichier donné.
 *
 * @param {Blob} blob - Contenu à télécharger
 * @param {string} filename - Nom de fichier proposé au navigateur
 */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Transforme un libellé libre en fragment de nom de fichier sûr.
 *
 * @param {string} label - Libellé brut (nom d'établissement, filtre)
 * @return {string} Fragment en minuscules, sans accent ni caractère spécial
 */
export function toFilenameFragment(label) {
  return String(label || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
}
